module.exports = __webpack_public_path__ + "resources/img/img_hi_psm3.e70fecbcbbe8a36cc2de495670636c1f.png";